module.exports = __webpack_public_path__ + "img/otp-phone.363d1f71.jpg";